export default __webpack_public_path__ + "static/media/0175.c47ee75d.png";